import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatRuntime',
  standalone: true
})
export class FormatRuntimePipe implements PipeTransform {
  // Accepts null as well as undefined: a nullable C# TimeSpan serializes to JSON null.
  transform(runtime: string | undefined | null): string {
    if (!runtime) return '';
    
    // Parse TimeSpan format from C# (e.g., "00:05:30.1234567")
    const parts = runtime.split(':');
    if (parts.length < 3) return runtime;
    
    const hours = parseInt(parts[0]);
    const minutes = parseInt(parts[1]);
    const seconds = Math.floor(parseFloat(parts[2]));
    
    if (hours > 0) {
      return `${hours}h ${minutes}m ${seconds}s`;
    } else if (minutes > 0) {
      return `${minutes}m ${seconds}s`;
    } else {
      return `${seconds}s`;
    }
  }
}
